import { WorkspaceShell } from "@/components/WorkspaceShell";

export default function TenantAdminShell() {
  return <WorkspaceShell />;
}
